export const CURRENT_OS = process.env.VITE_OS !== '' ? process.env.VITE_OS : 'webapp'
export const CURRENT_BRAND = process.env.VITE_BRAND !== '' ? process.env.VITE_BRAND : 'spectaflow'
